"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _crud = require("@crud/crud");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var defaultForm = {
  id: null,
  name: '',
  jobSort: 999,
  enabled: true
};
var _default = {
  mixins: [(0, _crud.form)(defaultForm)],
  props: {
    jobStatus: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      rules: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        jobSort: [{
          required: true,
          message: '请输入序号',
          trigger: 'blur',
          type: 'number'
        }]
      }
    };
  }
};
exports.default = _default;